import "./LinkedInButton.css";
import { LinkedIn } from "@mui/icons-material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { SxProps, Theme } from '@mui/material/styles';

interface LinkedInButtonProps {
  linkedin: string;
  linkedinFontSize?: string | number;
  linkedinIconScale?: string | number;
  iconTextGap?: string | number;
  sx?: SxProps<Theme>;
}

const LinkedInButton: React.FC<LinkedInButtonProps> = ({
  linkedin,
  linkedinFontSize = '19px',
  linkedinIconScale = '2.0',
  iconTextGap = '15px',
  sx,
}) => {
  return (
    <Button
      className='linkedin-button'
      href={linkedin}
      target="_blank"
      rel="noopener noreferrer"
      sx={{ gap: iconTextGap, ...sx }}
    >
      <Box className='linkedin-icon'>
        <LinkedIn
          sx={{
            transform: `scale(${linkedinIconScale})`,
            color: 'var(--color-palette-4)',
          }}
        />
      </Box>
      <Box className='linkedin-text' sx={{ fontSize: linkedinFontSize }}>
        {linkedin}
      </Box>
    </Button>
  );
};

export default LinkedInButton;